import { Card, Button, notification, Divider } from "antd";
import { backendURL } from "../Globals";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

import { LockOutlined, UserOutlined, LoginOutlined } from "@ant-design/icons";
import { Checkbox, Form, Input } from "antd";

const LoginUserComponent = ({ setLogin }) => {
  const navigate = useNavigate();

  const onFinish = (values) => {
    clickLogin(values);
  };

  const clickLogin = async (values) => {
    try {
      let response = await fetch(`${backendURL}/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: values.username,
          password: values.password,
        }),
      });

      if (response.ok) {
        let jsonData = await response.json();

        if (jsonData.apiKey) {
          const expiryDays = values.remember ? 7 : 1;
          localStorage.setItem("apiKey", jsonData.apiKey);
          Cookies.set("apiKey", jsonData.apiKey, { expires: expiryDays, secure: true, sameSite: "strict" });

          setLogin(true);
          navigate("/dashboards");
        } else {
          throw new Error("No API Key received");
        }
      } else {
        let errorData = await response.json();
        notification.error({
          message: "Error de inicio de sesión",
          description: errorData.error || "Credenciales incorrectas",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error de conexión",
        description: "No se pudo conectar con el servidor. Inténtalo más tarde.",
      });
    }
  };

  return (
    <Card
      style={{
        width: 400,
        boxShadow: "0 12px 40px rgba(0,0,0,0.15)",
        borderRadius: 18,
        borderTop: "5px solid #007398",
        backgroundColor: "#fff",
      }}
    >
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <div style={{
              width: 56, height: 56, borderRadius: "50%",
              background: "linear-gradient(135deg, #007398, #00a8c8)",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              marginBottom: 12,
            }}>
              <LockOutlined style={{ color: "#fff", fontSize: 24 }} />
            </div>
            <div style={{ fontWeight: 700, fontSize: 20, color: "#1a1a2e" }}>Acceso Administración</div>
            <div style={{ fontSize: 13, color: "#888", marginTop: 4 }}>Biblioteca de la Universidad de Oviedo</div>
          </div>
          <Divider style={{ marginTop: 0, marginBottom: 20 }} />
          <Form name="login-form" initialValues={{ remember: true }} onFinish={onFinish}>
            <Form.Item name="username" rules={[{ required: true, message: "Introduce tu usuario" }]}>
              <Input prefix={<UserOutlined style={{ color: "#007398" }} />} placeholder="Usuario" size="large" />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true, message: "Introduce tu contraseña" }]}>
              <Input.Password prefix={<LockOutlined style={{ color: "#007398" }} />} placeholder="Contraseña" size="large" />
            </Form.Item>
            <Form.Item name="remember" valuePropName="checked">
              <Checkbox>Recordarme (7 días)</Checkbox>
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                icon={<LoginOutlined />}
                style={{ background: "#007398", borderColor: "#007398", borderRadius: 8 }}
              >
                Iniciar sesión
              </Button>
            </Form.Item>
          </Form>
    </Card>
  );
};

export default LoginUserComponent;

